<template lang="pug">
div
  .text-body-1.font-weight-bold {{ title }}
  v-divider.mb-3
  v-responsive.mb-6(v-for="(v, i) in items", :key="i", :aspect-ratio="16 / 9")
    iframe(
      :src="`https://www.youtube.com/embed/${getYoutubeCode(v)}`",
      width="100%",
      height="100%",
      frameborder="0",
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowfullscreen>
    )
</template>

<script>
import { getYoutubeCode } from "@/components/utils.js";

const _config = {
  title: "Vídeos",
};

export default {
  data: () => ({ ..._config }),
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getYoutubeCode,
  },
};
</script>

<style>
</style>
